import { useQuery } from 'react-query';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export interface RecentOfflineBox {
  box_id: number;
  cmb_number: number | null;
  bluetooth: string | null;
  company_id: number | null;
  company_name: string | null;
  project_id: number | null;
  project_name: string | null;
  minutes_threshold: number | null;
  session_last_seen_at: string | null;
  notified_at: string;
  current_last_seen_at: string | null;
  recovered: boolean;
  delivery: {
    email:    { ok: boolean; recipients?: string[] } | null;
    whatsapp: { ok: boolean; recipients?: string[] } | null;
    webhook:  { ok: boolean; recipients?: string[] } | null;
  };
}

export type OfflineWindow = 24 | 168 | 720; // 24h, 7d, 30d

export interface UseRecentOfflineBoxesInput {
  company_id?: number;
  window_hours: OfflineWindow;
  include_recovered: boolean;
  email_only?: boolean;
}

// React-query key com os inputs de filtro pra invalidação seletiva
// não afetar outros ranges. Prefixo compartilhado ['sensors-v2',
// 'recent-offline'] permite invalidar em massa quando presence_changed
// chega ou quando o Redis pub/sub notificar novo email (PR seguinte).
export const RECENT_OFFLINE_KEY_PREFIX = ['sensors-v2', 'recent-offline'] as const;

export function useRecentOfflineBoxes(input: UseRecentOfflineBoxesInput) {
  return useQuery(
    [...RECENT_OFFLINE_KEY_PREFIX, input.company_id, input.window_hours, input.include_recovered, input.email_only ?? false],
    async () => {
      const params: Record<string, string | number | boolean> = {
        window_hours: input.window_hours,
        include_recovered: input.include_recovered,
      };
      if (input.company_id) params.company_id = input.company_id;
      if (input.email_only) params.email_only = true;
      const { data } = await axios.get<{ data: RecentOfflineBox[] }>(
        `${API_URL}/notifications/box-offline/recent`,
        { params },
      );
      return data.data ?? [];
    },
    {
      enabled: !!input.company_id,
      refetchInterval: 30_000,
      refetchOnWindowFocus: false,
      staleTime: 15_000,
    },
  );
}
